import styled from 'styled-components';

import { BaseButton } from '@r1-frontend/ui-react/components/buttons/baseButton';
import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { BorderRadius } from '@r1-frontend/ui-react/tokens/borderRadius';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

export const Wrapper = styled.div`
    align-items: center;
    justify-content: space-between;
    padding: 16px 24px;
    background-color: ${COLORS.BgSurface};
    border-radius: ${BorderRadius.OuterBlockRadius};
    flex-wrap: nowrap;
    width: 100%;

    @media (max-width: ${wideBreakpoints.mobile}) {
        flex-direction: column;
        align-items: baseline;
    }
`;

export const Text = styled.div`
    display: block;
    max-width: 700px;
    ${FONTS.S};
    color: ${COLORS.TextSecondary};
`;

export const Phone = styled.a`
    ${FONTS.S};
    color: ${COLORS.TextSecondary};
    text-decoration: none;
`;

export const StBaseButton = styled(BaseButton)`
    margin-left: 24px;

    @media (max-width: ${wideBreakpoints.mobile}) {
        margin-left: 0;
        margin-top: 24px;
        width: 100%;
    }
`;
